export default __webpack_public_path__ + "static/johnDexheimer@2x-0d55b90c06426e3e297d6b4dea72995d.jpg";